import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { IndividualType } from 'store/individuals/individual';

export type NewTeamFormValues = {
    name: string | null;
    market: DeclarationCountry | null;
};

export interface NewTeamMemberFormValues {
    assignee: string | null;
    name: string;
    email: string;
    role: IndividualType | null;
}

export const ALLOWED_NEW_MEMBER_ROLES = [
    IndividualType.TEAM_MANAGER,
    IndividualType.JOB_MANAGER,
    IndividualType.CLEARANCE_AGENT,
];

export const TeamPageTabKeys = {
    MANIFESTS: 'manifests',
    JOBS: 'jobs',
    PARTIES: 'parties',
    DETAILS: 'details',
    MEMBERS: 'members',
    INVOICES: 'invoices',
} as const;

export type TeamPageTabKey = typeof TeamPageTabKeys[keyof typeof TeamPageTabKeys];

export type AssignTeamManagerFieldValues = {
    teamManagerId: string | null;
    name: string | null;
    email: string | null;
    role: IndividualType.TEAM_MANAGER;
};
